import { z } from 'zod';
import { applySignatureRefinement, signatureDetailsSchema } from '../shared/signature';
export const abnValidationSchema = z.object({
    id: z.string(),
    data: z
        .object({
        services: z
            .array(z.object({
            service: z.string(),
            reason: z.string(),
            estimatedCost: z.string(),
        }))
            .optional(),
        language: z.string({ message: 'Please select a language' }),
        serviceOption: z.string({ message: 'Please select an option' }),
        patientSigned: z.boolean().nullish(),
        additionalNotes: z.string().optional(),
        signedDate: z.string().optional(),
        signatureDetails: signatureDetailsSchema,
    })
        .superRefine((data, ctx) => {
        applySignatureRefinement(ctx, data);
    }),
});
